import * as fetch from "../../common/fetch";

import { GroupGetUsersResponseType } from "../responses/groupResponseTypes";

import type {
  UserGetResponseType,
  UserGetAllResponseType,
  UserGetMyselfResponseType,
  UserGetPoliciesResponseType
} from "../responses/userResponseTypes";

import type {
  UserDeleteRequestType,
  UserCreateRequestType,
  UserInitializeRequestType,
  UserUpdateRequest
} from "../requests/userRequestTypes";

const url = process.env.WIB_API_URL;

export async function getAll() {
  const response = await fetch.get(`${url}/users`);

  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as UserGetAllResponseType;
  }
}

export async function getById(id) {
  const response = await fetch.get(`${url}/users/${id}`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as UserGetResponseType;
  }
}

export async function getGroups(id) {
  const response = await fetch.get(`${url}/users/${id}/groups`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as GroupGetUsersResponseType;
  }
}

export async function getPolicies(id) {
  const response = await fetch.get(`${url}/users/${id}/policies`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as UserGetPoliciesResponseType;
  }
}

export async function createUser(body: UserCreateRequestType) {
  const response = await fetch.post(`${url}/users`, body);

  if (!response.ok) {
    return false;
  }

  // Some endpoints return 201 with a JSON body, others may return 204 or empty.
  // Avoid "Unexpected end of JSON input" by checking for content first.
  const contentType = response.headers.get("content-type") ?? "";
  const hasJson = contentType.includes("application/json");

  // No JSON payload to read
  if (!hasJson) {
    return true;
  }

  // Empty JSON body
  const text = await response.text();
  if (!text) {
    return true;
  }

  return JSON.parse(text) as UserGetResponseType;
}

export async function initializeUser(id, body: UserInitializeRequestType) {
  const response = await fetch.post(`${url}/users/${id}/initialize`, body);
  return response.ok;
}

export async function updateUser(id, body: UserUpdateRequest) {
  const response = await fetch.put(`${url}/users/${id}`, body);
  return response.ok;
}

export async function getMyself() {
  const response = await fetch.get(`${url}/users/myself`);

  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as UserGetMyselfResponseType;
  }
}

export async function deleteUser(id, body: UserDeleteRequestType) {
  const response = await fetch.del(`${url}/users/${id}`, body);
  return response.ok;
}

export async function updateMyActivity() {
  const response = await fetch.put(`${url}/users/myself/activity`, {});
  return response.ok;
}
